const TONES = ["success", "warning", "danger", "info", "muted", "deleted"];

export function StatusBadge({ label, tone = "muted", dot = true }) {
  const safeTone = TONES.includes(tone) ? tone : "muted";
  return (
    <span className={`badge-pill badge-pill--${safeTone}`}>
      {dot && <span className="badge-pill-dot" aria-hidden="true" />}
      {label}
    </span>
  );
}

const KNOWLEDGE_BASE_STATUS_TONES = {
  Done: "success",
  Processing: "info",
  Pending: "warning",
  Failed: "danger",
};

export function KnowledgeBaseStatusBadge({ status }) {
  return <StatusBadge label={status || "Unknown"} tone={KNOWLEDGE_BASE_STATUS_TONES[status] || "muted"} />;
}

export function AgentStatusBadge({ status, isDeleted }) {
  if (isDeleted) {
    return <StatusBadge label="Deleted" tone="danger" />;
  }
  const isDisabled = status === "Disabled";
  return (
    <StatusBadge
      label={isDisabled ? "Disabled" : "Active"}
      tone={isDisabled ? "danger" : "success"}
    />
  );
}
